import React from 'react';
import { motion } from 'framer-motion';

const Reveal = ({ children, delay = 0, y = 22, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.6, delay, ease: [0.21, 0.5, 0.15, 1] }}
  >
    {children}
  </motion.div>
);

export default Reveal;
